/* eslint-disable no-param-reassign */

// LIBRARY
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { pick } from 'lodash';
import ReactRouterPropTypes from 'react-router-prop-types';
import { GLOBAL_TABLE_SIZE } from 'global_config/constant-global';
import { Table as AntTable, Spin } from 'antd';

// CSS
import './table.css';

const personalInfoKeys = [
	'hospitalID',
	'patientID',
	'emailAdd',
	'givenName',
	'middleName',
	'lastName',
	'nameSuffix',
	'dateOfBirth',
	'sex',
	'address',
	'addressCode',
	'contactNumber',
];

class SearchPatientTable extends React.Component {
	handleSubmit = fields => {
		delete fields.dateCreated;
		delete fields.addressID;

		// Save personal and other info to session storage
		// for edit module
		const personalInfo = pick(fields, personalInfoKeys);

		// Convert each field's value to uppercase
		Object.keys(personalInfo).forEach(field => {
			if (personalInfo[field] !== undefined && personalInfo[field] !== null)
				personalInfo[field] = personalInfo[field].toUpperCase();
		});

		delete personalInfo.patientID;
	};

	render() {
		// CONSTANTS
		const { data, pageSize, currentPage, loading, handleDoubleClick, ...rest } = this.props;
		const getSorter = (myDataSource, columnName) => {
			if (myDataSource.length > 0) {
				const columnSorter = (a, b) => {
					if (a[columnName] !== null) {
						return a[columnName].localeCompare(b[columnName]);
					}
					return 1;
				};

				return columnSorter;
			}
			return false;
		};

		const Searchcolumns = [
			{
				title: 'PATIENT ID',
				dataIndex: 'patientID',
				sorter: getSorter(data, 'patientID'),
				width: 100,
			},
			{
				title: 'LAST NAME',
				dataIndex: 'lastName',
				sorter: getSorter(data, 'lastName'),
				width: 150,
			},
			{
				title: 'FIRST NAME',
				dataIndex: 'givenName',
				sorter: getSorter(data, 'givenName'),
				width: 150,
			},
			{
				title: 'MIDDLE NAME',
				dataIndex: 'middleName',
				sorter: getSorter(data, 'middleName'),
				width: 150,
			},
			{
				title: 'BIRTHDATE',
				dataIndex: 'dateOfBirth',
				sorter: getSorter(data, 'dateOfBirth'),
				width: 100,
			},
			{
				title: 'GENDER',
				dataIndex: 'sex',
				sorter: getSorter(data, 'sex'),
				width: 80,
			},
			{
				title: 'ADDRESS',
				dataIndex: 'address',
				sorter: getSorter(data, 'address'),
				render: (text, row) => {
					const { address, townName, cityMunicipalityName, provinceName } = row;

					if (row.address)
						return `${address}, ${townName}, ${cityMunicipalityName}, ${provinceName}`.toUpperCase();

					return '';
				},
				width: 400,
			},
		];

		return (
			<Spin spinning={loading} tip="Loading...">
				<div className="search-patient-demographics-table">
					<AntTable
						size={GLOBAL_TABLE_SIZE}
						pagination={{ pageSize, current: currentPage, showSizeChanger: false }}
						columns={Searchcolumns}
						dataSource={data}
						rowKey={record => record.key}
						onRow={record => {
							return {
								onDoubleClick: () => {
									handleDoubleClick(record);
								},
							};
						}}
						scroll={{ x: 1500 }}
						// scroll={{ y: 'calc(100vh - 450px)' }}
						{...rest}
					/>
				</div>
			</Spin>
		);
	}
}

SearchPatientTable.propTypes = {
	history: ReactRouterPropTypes.history.isRequired,
	data: PropTypes.arrayOf(
		PropTypes.shape({
			givenName: PropTypes.string.isRequired,
			lastName: PropTypes.string.isRequired,
			middleName: PropTypes.string.isRequired,
			dateOfBirth: PropTypes.string.isRequired,
			sex: PropTypes.string.isRequired,
			contactNo: PropTypes.string,
			emailAdd: PropTypes.string,
		}),
	).isRequired,
	pageSize: PropTypes.number.isRequired,
	currentPage: PropTypes.number.isRequired,
	loading: PropTypes.bool.isRequired,
	handleDoubleClick: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
};

export default withRouter(SearchPatientTable);
